import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=9a203a38&scoped=true&"
import script from "./Index.js?vue&type=script&lang=js&"
export * from "./Index.js?vue&type=script&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&id=9a203a38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a203a38",
  null
  
)

export default component.exports